import React from 'react';
import { pricingTypes } from 'utils/constant';
import { formatAmount } from 'utils/services';

const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return 'N/A';
  return value?.toLocaleString?.('en-US', { maximumSignificantDigits: 21 }) ?? value;
};

const formatUpperLimit = (value) => {
  if (value === null || value === Infinity || value === 'Infinity') return 'Infinity';
  return formatNumber(value);
};

const DetailGrid = ({ items }) => (
  <div className='detail-card pricing-schema-card'>
    {items?.map((item, index) => (
      <div key={index} className='detail-value'>
        <h2>{item?.label}</h2>
        <span>{item?.value ?? 'N/A'}</span>
      </div>
    ))}
  </div>
);

const TierTable = ({ tiers, currency }) => (
  <div className='tier-table-wrapper'>
    <table className='invoice-tier-table'>
      <thead>
        <tr>
          <th>Tier</th>
          <th>Lower Limit</th>
          <th>Upper Limit</th>
          <th>Price Per Unit</th>
          <th>Flat Fee</th>
        </tr>
      </thead>
      <tbody>
        {tiers?.map((tier, index) => (
          <tr key={tier?._id || index}>
            <td>{index + 1}</td>
            <td>{formatNumber(tier?.lowerLimit)}</td>
            <td>{formatUpperLimit(tier?.upperLimit)}</td>
            <td>{currency ? `${currency} ${formatAmount(tier?.pricePerUnit, currency)}` : formatNumber(tier?.pricePerUnit)}</td>
            <td>{currency ? `${currency} ${formatAmount(tier?.flatFee, currency)}` : formatNumber(tier?.flatFee)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const PricingSchemaDetails = ({ pricingType, pricingSchema, currency }) => {
  if (!pricingType) return null;

  if (pricingType === pricingTypes.TIERED || pricingType === pricingTypes.VOLUME) {
    const tiers = Array.isArray(pricingSchema) ? pricingSchema?.filter((tier) => tier?._delete !== true) : [];
    if (!tiers?.length) {
      return <div className='pricing-schema-empty'>No tier configuration available.</div>;
    }

    return (
      <>
        <div className='breakdown-heading'>
          <h3>{pricingType === pricingTypes.TIERED ? 'Tiered' : 'Volume'} Pricing</h3>
        </div>
        <TierTable tiers={tiers} currency={currency} />
      </>
    );
  }

  if (pricingType === pricingTypes.PERCENTAGE) {
    const schema = pricingSchema && !Array.isArray(pricingSchema) ? pricingSchema : {};
    return (
      <>
        <div className='breakdown-heading'>
          <h3>Percentage Pricing</h3>
        </div>
        <DetailGrid
          items={[
            { label: 'Percentage', value: schema?.percentage !== undefined && schema?.percentage !== null ? `${schema?.percentage}%` : 'N/A' },
            {
              label: 'Flat Fee',
              value: schema?.flatFee !== undefined && schema?.flatFee !== null ? (currency ? `${currency} ${formatAmount(schema?.flatFee, currency)}` : formatNumber(schema?.flatFee)) : 'N/A',
            },
          ]}
        />
      </>
    );
  }

  if (pricingType === pricingTypes.STANDARD) {
    const schema = pricingSchema && !Array.isArray(pricingSchema) ? pricingSchema : {};
    return (
      <>
        <div className='breakdown-heading'>
          <h3>Standard Pricing</h3>
        </div>
        <DetailGrid
          items={[
            {
              label: 'Amount',
              value: schema?.amount !== undefined && schema?.amount !== null ? (currency ? `${currency} ${formatAmount(schema?.amount, currency)}` : formatNumber(schema?.amount)) : 'N/A',
            },
          ]}
        />
      </>
    );
  }

  if (pricingType === pricingTypes.FIXED) {
    const schema = pricingSchema && !Array.isArray(pricingSchema) ? pricingSchema : {};
    return (
      <>
        <div className='breakdown-heading'>
          <h3>Fixed Retainer Pricing</h3>
        </div>
        <DetailGrid
          items={[
            {
              label: 'Amount',
              value: schema?.amount !== undefined && schema?.amount !== null ? (currency ? `${currency} ${formatAmount(schema?.amount, currency)}` : formatNumber(schema?.amount)) : 'N/A',
            },
          ]}
        />
      </>
    );
  }

  return null;
};

export default PricingSchemaDetails;
